<template>
  <input ref="input" type="text" />
</template>

<script>
import { attachPlacesAutocomplete } from "../utils/placesAutocomplete";

// Drop-in replacement for vue2-google-maps' <gmap-autocomplete>, which wraps the
// legacy google.maps.places.Autocomplete (unavailable to new Cloud projects).
// Emits "place_changed" with { formatted_address, address_components }.
export default {
  name: "PlacesAutocompleteInput",
  props: {
    selectFirstOnEnter: { type: Boolean, default: false }
  },
  mounted() {
    this.destroyAutocomplete = attachPlacesAutocomplete(
      this.$refs.input,
      place => this.$emit("place_changed", place),
      { selectFirstOnEnter: this.selectFirstOnEnter }
    );
  },
  beforeDestroy() {
    if (this.destroyAutocomplete) this.destroyAutocomplete();
  }
};
</script>
